import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const NewCustomRoleManagementWrapper = lazy(() =>
  import("@scenes/PermissionSettings/components/CustomRoleManagement/NewCustomRoleManagementWrapper").then(
    (module) => ({
      default: module.NewCustomRoleManagementWrapper,
    })
  )
);

export const newPermissionSettingsRoleNRO: NavigationRoutingObject = {
  Component: NewCustomRoleManagementWrapper,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("new-role-nro-heading", "New Role"),
  pageNameForTracking: () => "New Role",
  getDeveloperNavigationAllowed: ({ hasPermission }) => {
    return hasPermission("company", {
      permission: "manageCompanySettings",
    });
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/company_settings/user_management/roles/:appGroupId",
};
